import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { DashboardForm } from '../components';
import Frame from '../layout/Frame';
import { createDashboard } from '../requests/requests';
import useErrorHandler from '../hooks/useErrorHandler';
import { AppRoute } from '../types/enums';
import { DataContext } from '../App';
import Panel from '../layout/Panel';
import { SaveDashboard } from '../types/types';

const NewDashboard = () => {
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { refreshDashboards } = useContext(DataContext);

  const onSubmit: SaveDashboard = useCallback((payload) => {
    createDashboard(payload).then(({ data }) => {
      refreshDashboards();
      navigate(AppRoute.DASHBOARD_CREATED, {
        state: data
      });
    }, errorHandler);
  }, []);

  return (
    <Frame>
      <Panel>
        <h1>ADD NEW DASHBOARD</h1>
        <DashboardForm onSave={onSubmit} />
      </Panel>
    </Frame>
  );
};

export default NewDashboard;
